import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import PageHeading from "../components/styled/page-heading"
import Login from '../components/Login'

import './login.css'

const LoginPage = ({ location }) => {
  const seo = { title: "Login"}
  const { state: routeState } = location
  const redirect = !routeState
    ? '/app'
    : routeState.redirect === 'app'
        ? '/app'
        : `/innerapp/home`

  return (
    <div id="lay">
      <Layout>
        <SEO seo={seo} />
        <div id="logbox">
          <div id="signside">
            <div id="topbox">
              <h1 className="tit">Sign In</h1>

              <Link to="/" id="homelink">
                <div id="homelinkbox">Homepage</div>
              </Link>
            </div>
            <br/><br/>
          
            <div>
                <Login redirect={redirect} />
            </div>
            <br />
            
          </div>
          <div id="regside">
            <p id="uptext">
              <h2>Aren't a member yet?</h2>
              <Link to="/register/" id="reglink">
                <div id="reglinkbox">Sign Up</div>
              </Link> <br />
              <br />
            </p>
          </div>
        </div>
      </Layout>
    </div>
  )
}



export default LoginPage